<template>
  <AuthWrap :title="$t('register.signIn')" :text="$t('register.enterOwnData')">
    <PrimaryInput
      :errText="error.first_name_ko ? $t('register.errNameKorean') : ''"
      class="input"
      :success="success.first_name_ko"
    >
      <input
        @input="inputKorName(first_name_ko)"
        v-model="first_name_ko"
        type="text"
        @blur="success.first_name_ko = first_name_ko.length != 0"
        class="border-input"
        :placeholder="$t('register.nameKorean')"
      />
    </PrimaryInput>
    <PrimaryInput
      class="input"
      :errText="error.last_name_ko ? $t('register.errsScondnameKorean') : ''"
      :success="success.last_name_ko"
    >
      <input
        @input="inputKorText(last_name_ko)"
        v-model="last_name_ko"
        type="text"
        @blur="success.last_name_ko = last_name_ko.length != 0"
        class="border-input"
        :placeholder="$t('register.secondnameKorean')"
      />
    </PrimaryInput>
    <PrimaryInput
      class="input"
      :errText="error.first_name ? $t('register.nameEng') : ''"
      :success="success.first_name"
    >
      <input
        @input="inputEngName(first_name)"
        v-model="first_name"
        type="text"
        @blur="success.first_name = first_name.length != 0"
        :placeholder="$t('register.nameEng')"
      />
    </PrimaryInput>
    <PrimaryInput
      :errText="error.last_name ? $t('register.errSecondnameEng') : ''"
      class="input"
      :success="success.last_name"
    >
      <input
        @input="inputEngText(last_name)"
        v-model="last_name"
        type="text"
        @blur="success.last_name = last_name.length != 0"
        :placeholder="$t('register.secondnameEng')"
      />
    </PrimaryInput>

    <PrimarySelect
      iconPath="M32.5827 17.0003C32.5827 8.39389 25.6058 1.41699 16.9993 1.41699C8.39291 1.41699 1.41602 8.39389 1.41602 17.0003C1.41602 25.6068 8.39291 32.5837 16.9993 32.5837C25.6058 32.5837 32.5827 25.6068 32.5827 17.0003ZM28.8394 12.2609C27.5454 9.03129 24.9684 6.45423 21.7388 5.16028C22.4965 6.62306 23.0909 8.44683 23.4916 10.5081C25.5528 10.9087 27.3766 11.5032 28.8394 12.2609ZM10.5071 10.5081C10.9078 8.44683 11.5022 6.62306 12.2599 5.16028C9.03031 6.45423 6.45325 9.03128 5.1593 12.2609C6.62208 11.5032 8.44585 10.9087 10.5071 10.5081ZM4.24935 17.0003C4.24935 15.7264 6.55665 14.3441 10.0782 13.5128C9.97133 14.6356 9.91602 15.8033 9.91602 17.0003C9.91602 18.1974 9.97133 19.365 10.0782 20.4879C6.55665 19.6566 4.24935 18.2743 4.24935 17.0003ZM5.1593 21.7398C6.62208 22.4975 8.44585 23.0919 10.5071 23.4925C10.9078 25.5538 11.5022 27.3776 12.2599 28.8404C9.03031 27.5464 6.45325 24.9694 5.1593 21.7398ZM23.4916 23.4925C23.0909 25.5538 22.4965 27.3776 21.7388 28.8404C24.9684 27.5464 27.5454 24.9694 28.8394 21.7398C27.3766 22.4975 25.5528 23.0919 23.4916 23.4925ZM24.0827 17.0003C24.0827 18.1974 24.0274 19.365 23.9205 20.4879C27.442 19.6566 29.7493 18.2743 29.7493 17.0003C29.7493 15.7264 27.442 14.3441 23.9205 13.5128C24.0274 14.6356 24.0827 15.8033 24.0827 17.0003ZM12.7493 17.0003C12.7493 15.5975 12.8373 14.2516 12.9939 12.9949C14.2506 12.8383 15.5965 12.7503 16.9993 12.7503C18.4022 12.7503 19.7481 12.8383 21.0048 12.9949C21.1614 14.2516 21.2493 15.5975 21.2493 17.0003C21.2493 18.4032 21.1614 19.7491 21.0048 21.0058C19.7481 21.1623 18.4022 21.2503 16.9993 21.2503C15.5965 21.2503 14.2506 21.1623 12.9939 21.0058C12.8373 19.7491 12.7493 18.4032 12.7493 17.0003ZM13.5118 23.9215C14.3431 27.443 15.7254 29.7503 16.9993 29.7503C18.2733 29.7503 19.6556 27.443 20.4869 23.9215C19.364 24.0283 18.1964 24.0837 16.9993 24.0837C15.8023 24.0837 14.6347 24.0283 13.5118 23.9215ZM16.9993 4.25033C15.7254 4.25033 14.3431 6.55763 13.5118 10.0792C14.6347 9.97231 15.8023 9.91699 16.9993 9.91699C18.1964 9.91699 19.364 9.97231 20.4869 10.0792C19.6556 6.55763 18.2733 4.25033 16.9993 4.25033Z"
      class="input"
      :class="{ error: error.citizenship }"
      :success="success.citizenship"
    >
      <select
        @blur="success.citizenship = citizenship != ''"
        v-model="citizenship"
        name="citizenship"
        class="border-input"
      >
        <option value="" disabled>{{ $t("register.citizenship") }}</option>
        <option
          v-for="item in choicesLabel?.citizenship"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </PrimarySelect>
    <PrimarySelect
      class="input"
      :success="success.nationality"
      :class="{ error: error.nationality }"
    >
      <select
        @blur="success.nationality = nationality != ''"
        v-model="nationality"
        name="nationality"
        class="border-input"
      >
        <option value="" disabled>{{ $t("register.nationality") }}</option>
        <option
          v-for="item in choicesLabel?.nationality"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </PrimarySelect>
    <PrimarySelect
      class="input"
      :success="success.purpose"
      :class="{ error: error.purpose }"
    >
      <select
        @blur="success.purpose = purpose != ''"
        v-model="purpose"
        name="purpose"
        class="border-input"
      >
        <option value="" disabled>{{ $t("register.purpose") }}</option>
        <option
          v-for="item in choicesLabel?.purpose"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </PrimarySelect>
    <PrimarySelect
      iconPath="M26.9173 14.167C26.9173 8.41649 23.7463 4.42528 19.6433 3.22708C19.4947 2.84267 19.2599 2.4853 18.9408 2.18543C17.8503 1.16084 16.151 1.16084 15.0605 2.18543C14.7421 2.48464 14.5076 2.8411 14.359 3.22455C10.2507 4.41753 7.08398 8.40002 7.08398 14.167C7.08398 17.8983 6.33171 19.9892 4.93909 21.5044C4.70625 21.7577 4.0754 22.338 3.64808 22.7311C3.44591 22.9171 3.28929 23.0612 3.24193 23.1089L2.83398 23.5226V28.3536H11.4586C11.7503 29.8582 12.5666 30.8648 14.0429 31.7657C15.859 32.8739 18.1423 32.8739 19.9584 31.7657C21.2612 30.9706 22.1349 29.7487 22.4893 28.3536H31.1673V23.5226L30.7594 23.1089C30.7165 23.0654 30.5664 22.927 30.3703 22.7461L30.3701 22.7458L30.3698 22.7456C29.9437 22.3526 29.3005 21.7592 29.0641 21.501C27.6705 19.9787 26.9173 17.8852 26.9173 14.167ZM19.461 28.3536H14.4204C14.6205 28.726 14.9617 29.0071 15.5188 29.3471C16.4287 29.9023 17.5726 29.9023 18.4825 29.3471C18.9038 29.09 19.233 28.7498 19.461 28.3536ZM26.9742 23.4142C27.2723 23.7398 27.9113 24.335 28.334 24.7239V25.5203H5.66732V24.7245C6.08675 24.3402 6.7276 23.7454 7.02517 23.4217C8.91747 21.3628 9.91732 18.5839 9.91732 14.167C9.91732 8.81184 13.2221 5.68453 17.0007 5.68453C20.7686 5.68453 24.084 8.82799 24.084 14.167C24.084 18.5697 25.0841 21.3495 26.9742 23.4142Z"
      class="input"
      :success="success.inform_source"
      :class="{ error: error.inform_source }"
    >
      <select
        @blur="success.inform_source = inform_source != ''"
        v-model="inform_source"
        name="inform_source"
        class="border-input"
      >
        <option value="" disabled>{{ $t("register.inform_source") }}</option>
        <option
          v-for="item in choicesLabel?.inform_source"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </PrimarySelect>

    <PrimaryButton
      style="margin-bottom: 1.875rem"
      :title="$t('buttons.next')"
      @click="handleCorrectInput"
    />
    <PrimaryButton
      :title="$t('register.prev')"
      @click="$emit('prev')"
      isOutlined
    />
  </AuthWrap>
</template>

<script>
/*eslint-disable*/
import { Icon } from "@iconify/vue";
import { useStore } from "vuex";
import { computed, reactive, toRefs } from "vue";
import AuthWrap from "@/components/AuthWrap";
import PrimaryInput from "../PrimaryInput.vue";
import PrimarySelect from "../PrimarySelect.vue";
import PrimaryButton from "../PrimaryButton.vue";

export default {
  components: { Icon, AuthWrap, PrimaryInput, PrimarySelect, PrimaryButton },
  setup(_, { emit }) {
    const store = useStore();
    const choicesLabel = computed(
      () => store.getters["register/getchoicesLabel"]
    );

    const inputEngText = (val) => {
      info.last_name = val.replace(/[^a-zA-Z]+/giu, "");
    };
    const inputEngName = (val) => {
      info.first_name = val.replace(/[^a-zA-Z]+/giu, "");
    };
    const inputKorText = (val) => {
      info.last_name_ko = val.replace(/[^\u3131-\uD79D]/giu, "");
    };
    const inputKorName = (val) => {
      info.first_name_ko = val.replace(/[^\u3131-\uD79D]/giu, "");
    };

    const info = reactive({
      last_name_ko: "",
      last_name: "",
      first_name_ko: "",
      first_name: "",
      citizenship: "",
      nationality: "",
      purpose: "",
      inform_source: "",
    });

    const error = reactive({
      last_name_ko: false,
      last_name: false,
      first_name_ko: false,
      first_name: false,
      citizenship: false,
      nationality: false,
      purpose: false,
      inform_source: false,
    });

    const success = reactive({
      last_name_ko: false,
      last_name: false,
      first_name_ko: false,
      first_name: false,
      citizenship: false,
      nationality: false,
      purpose: false,
      inform_source: false,
    });

    const handleCorrectInput = () => {
      for (const el in info) {
        if (info[el]) {
          error[el] = false;
        } else {
          error[el] = true;
        }
      }
      console.log(error);
      if (Object.values(error).indexOf(true) == -1) {
        console.log("##########");
        store.commit("register/setUser", {
          last_name_ko: info.last_name_ko,
          last_name: info.last_name.toUpperCase(),
          first_name_ko: info.first_name_ko,
          first_name: info.first_name.toUpperCase(),
          citizenship: info.citizenship,
          nationality: info.nationality,
          purpose: info.purpose,
          inform_source: info.inform_source,
        });

        emit("next");
      }
    };

    return {
      choicesLabel,
      handleCorrectInput,
      ...toRefs(info),
      error,
      inputEngText,
      inputKorText,
      // inputText,
      inputKorName,
      inputEngName,
      success,
      is_UZB: computed(() => store.getters["register/user"].uzbek_citizen),
    };
  },
};
</script>

<style lang="scss" scoped>
label {
  font-weight: 500;
  color: #a5a5a5;
  margin-bottom: 1em;
}
.row {
  display: flex;
  --gap-input: 66px;
  gap: 0 var(--gap-input);
}
.col {
  --gap-input: 66px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 var(--gap-input);
  // display: flex;
  // flex-wrap: wrap;
  // flex-direction: column;
  &__item {
    display: flex;
    flex-direction: column;
  }
}
@media screen and (max-width: 576px) {
  .col {
    &__item {
      grid-column: span 2;
      select {
        width: 100%;
      }
    }
  }
}
</style>
